import { createSlice } from '@reduxjs/toolkit';
import { ICustomer } from '../../../../dto';
import { setCustomers } from '../actions';
import { MN_CUSTOMERS, TYPE_LIST } from '../../../../common';

export interface CustomersState {
  data: ICustomer[];
  loading: boolean;
  error: string | null;
}

const initialState: CustomersState = {
  data: [],
  loading: false,
  error: null,
};

export const customersSlice = createSlice({
  name: `${MN_CUSTOMERS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setCustomers, (state, { payload }) => {
      state.data = payload;
    });
  },
});
